import Print from './print';

const printConfig = {
  name: 'print',
  class: Print,
  querySelector: {
    printToggle: '.print',
  },
  querySelectorAll: {},
  options: {},
};

export default printConfig;
